

























































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { CostCenterService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { CostCenterModel } from '@/models/config'

@Component({
    name: 'TableListCostCenter',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListCostCenter extends Vue {
    loading = false
    items: [CostCenterModel] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'name',
            sortable: true,
            label: 'Nombre'
        },
        {
            key: 'description',
            sortable: true,
            label: 'Descripción'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getCostCenterWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getCostCenterWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getCostCenterWithPagination()
    }

    async getCostCenterWithPagination () {
        this.loading = true
        const response = await CostCenterService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
